import * as z from 'zod';

import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

const configParameterSchema = z.object({
    id: z.number(),
});

const configSchema = z.object({
    parameters: z.array(configParameterSchema),
    tareCountDown: z.number(),
});

export type ConfigParameter = z.infer<typeof configParameterSchema>;
export type Config = z.infer<typeof configSchema>;

export const getLiveAnalysisConfig = withLogs(
    () =>
        apiClient.get(ApiConfig.path('/api/v1/live-feedback/config')).then((config) => configSchema.parse(config.data)),
    'getLiveAnalysisConfig',
);
